var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation"},[_c('repair-view-global',{attrs:{"repair":_vm.repair,"show-buttons":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }